import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IActiveShifts } from '../../models/dashboard/jobs/getActiveShifts.model';

interface IPendingJobApplicationsState {
  jobData: IActiveShifts[];
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
}

const initialState: IPendingJobApplicationsState = {
  jobData: [],
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: false,
  last: false,
};

const pendingJobApplicationsSlice = createSlice({
  name: 'pendingJobApplications',
  initialState,
  reducers: {
    pendingJobApplications(state, action: PayloadAction<IPendingJobApplicationsState>) {
      return { ...state, ...action.payload };
    },
  },
});

export const pendingJobApplicationsActions = pendingJobApplicationsSlice.actions;
export default pendingJobApplicationsSlice.reducer;
